import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  HostListener
} from '@angular/core';

@Component({
  selector: 'app-modal',
  imports: [
    CommonModule,
  ],
  templateUrl: './modal.component.html',
  styles: `
    :host {
      display: block;
    }
    .modal {
      pointer-events: auto;
    }
    .modal-backdrop {
      animation: modalBackdropFadeIn 180ms ease-out;
    }
    .modal-panel {
      animation: modalPanelEnter 220ms cubic-bezier(0.16, 1, 0.3, 1);
      will-change: opacity, transform;
    }
    .modal-panel-fullscreen {
      animation: modalPanelFadeIn 180ms ease-out;
      will-change: opacity;
    }
    @keyframes modalBackdropFadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @keyframes modalPanelEnter {
      from {
        opacity: 0;
        transform: translateY(8px) scale(0.98);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
    @keyframes modalPanelFadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `
})
export class ModalComponent implements OnInit, OnDestroy, OnChanges {

  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();
  @Input() className = '';
  @Input() showCloseButton = true;
  @Input() isFullscreen = false;
  @Input() preventDismiss = false; // When true, prevents closing via backdrop click or escape key

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    if (this.isOpen) {
      document.body.style.overflow = 'hidden';
    }
  }

  ngOnDestroy(): void {
    document.body.style.overflow = 'unset';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      document.body.style.overflow = this.isOpen ? 'hidden' : 'unset';
    }
  }

  onBackdropClick(event: MouseEvent) {
    if (!this.isFullscreen && !this.preventDismiss) {
      this.close.emit();
    }
    // When preventDismiss is true, block all interactions with backdrop
    if (this.preventDismiss) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onContentClick(event: MouseEvent) {
    event.stopPropagation();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (this.isOpen && !this.preventDismiss) {
      this.close.emit();
    }
  }
}
